export const isEmail = (email: string) => {
  const re = /^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/

  return re.test(email)
}
